import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "common-layout"
};
import TopHerder from "./components/TopHerder.vue";
export default {
  __name: 'App',
  setup(__props) {
    return (_ctx, _cache) => {
      const _component_el_menu_item = _resolveComponent("el-menu-item");
      const _component_el_menu_item_group = _resolveComponent("el-menu-item-group");
      const _component_el_menu = _resolveComponent("el-menu");
      const _component_el_aside = _resolveComponent("el-aside");
      const _component_el_header = _resolveComponent("el-header");
      const _component_router_view = _resolveComponent("router-view");
      const _component_el_main = _resolveComponent("el-main");
      const _component_el_container = _resolveComponent("el-container");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_container, null, {
        default: _withCtx(() => [_createVNode(_component_el_aside, {
          width: "150px"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_menu, {
            "default-active": "2",
            class: "el-menu-vertical-demo",
            router: ""
          }, {
            default: _withCtx(() => [_createVNode(_component_el_menu_item_group, null, {
              default: _withCtx(() => [_createVNode(_component_el_menu_item, {
                index: "/attendance"
              }, {
                default: _withCtx(() => _cache[0] || (_cache[0] = [_createTextVNode("考勤统计")])),
                _: 1
              }), _createVNode(_component_el_menu_item, {
                index: "/attendGroup"
              }, {
                default: _withCtx(() => _cache[1] || (_cache[1] = [_createTextVNode("考勤组管理")])),
                _: 1
              }), _createVNode(_component_el_menu_item, {
                index: "/attendClasses"
              }, {
                default: _withCtx(() => _cache[2] || (_cache[2] = [_createTextVNode("班次管理")])),
                _: 1
              }), _createVNode(_component_el_menu_item, {
                index: "/attendAddress"
              }, {
                default: _withCtx(() => _cache[3] || (_cache[3] = [_createTextVNode("打卡地管理")])),
                _: 1
              }), _createVNode(_component_el_menu_item, {
                index: "/attendScheduling"
              }, {
                default: _withCtx(() => _cache[4] || (_cache[4] = [_createTextVNode("排班")])),
                _: 1
              }), _createVNode(_component_el_menu_item, {
                index: "/attendReCard"
              }, {
                default: _withCtx(() => _cache[5] || (_cache[5] = [_createTextVNode("补卡规则")])),
                _: 1
              }), _createVNode(_component_el_menu_item, {
                index: "/attendHoliday"
              }, {
                default: _withCtx(() => _cache[6] || (_cache[6] = [_createTextVNode("节假日管理")])),
                _: 1
              }), _createVNode(_component_el_menu_item, {
                index: "/notClockIn"
              }, {
                default: _withCtx(() => _cache[7] || (_cache[7] = [_createTextVNode("不打卡人员")])),
                _: 1
              }), _createVNode(_component_el_menu_item, {
                index: "/employee"
              }, {
                default: _withCtx(() => _cache[8] || (_cache[8] = [_createTextVNode("员工管理")])),
                _: 1
              }), _createVNode(_component_el_menu_item, {
                index: "/attendLeave"
              }, {
                default: _withCtx(() => _cache[9] || (_cache[9] = [_createTextVNode("请假管理")])),
                _: 1
              }), _createVNode(_component_el_menu_item, {
                index: "/attendConfirm"
              }, {
                default: _withCtx(() => _cache[10] || (_cache[10] = [_createTextVNode("考勤确定")])),
                _: 1
              }), _createVNode(_component_el_menu_item, {
                index: "/attendAudit"
              }, {
                default: _withCtx(() => _cache[11] || (_cache[11] = [_createTextVNode("审核管理")])),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_el_container, null, {
          default: _withCtx(() => [_createVNode(_component_el_header, null, {
            default: _withCtx(() => [_createVNode(TopHerder)]),
            _: 1
          }), _createVNode(_component_el_main, null, {
            default: _withCtx(() => [_createVNode(_component_router_view)]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      })]);
    };
  }
};